if (!customElements.get('copy-link')) {
  customElements.define(
    'copy-link',
    class CopyLink extends HTMLElement {
      constructor() {
        super()
        this.url = this.dataset.shareLink
        this.addEventListener('click', this.copyToClipboard)
      }
      copyToClipboard() {
        navigator.clipboard.writeText(this.url).then(() => {
          this.classList.add('copied')
          setTimeout(() => {
            this.classList.remove('copied')
          }, 1000)
        })
      }
    }
  )
}
